import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteInspectorFeedbackMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeleteInspectorFeedbackMutation = { __typename?: 'mutation_root', delete_inspector_feedback_by_pk?: { __typename?: 'inspector_feedback', id: any } | null };


export const DeleteInspectorFeedbackDocument = gql`
    mutation deleteInspectorFeedback($id: uuid!) {
  delete_inspector_feedback_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteInspectorFeedbackMutationFn = Apollo.MutationFunction<DeleteInspectorFeedbackMutation, DeleteInspectorFeedbackMutationVariables>;

/**
 * __useDeleteInspectorFeedbackMutation__
 *
 * To run a mutation, you first call `useDeleteInspectorFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInspectorFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInspectorFeedbackMutation, { data, loading, error }] = useDeleteInspectorFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInspectorFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInspectorFeedbackMutation, DeleteInspectorFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInspectorFeedbackMutation, DeleteInspectorFeedbackMutationVariables>(DeleteInspectorFeedbackDocument, options);
      }
export type DeleteInspectorFeedbackMutationHookResult = ReturnType<typeof useDeleteInspectorFeedbackMutation>;
export type DeleteInspectorFeedbackMutationResult = Apollo.MutationResult<DeleteInspectorFeedbackMutation>;
export type DeleteInspectorFeedbackMutationOptions = Apollo.BaseMutationOptions<DeleteInspectorFeedbackMutation, DeleteInspectorFeedbackMutationVariables>;